import { telephonyProviders } from "@/src/constants/telephonyConstants";
import TwilioDevice from "../providers/twilio/twilioDevice";
import TwilioEventHandler from "../providers/twilio/twilioEventHandler";
import PlivoDevice from "../providers/plivo/plivoDevice";
import PlivoEventHandler from "../providers/plivo/plivoEventHandler";
import RetellDevice from "../providers/retell/retellDevice";
import RetellEventHandler from "../providers/retell/retellEventHandler";

class TelephonyFactory {
  createDevice(provider) {
    switch (provider) {
      case telephonyProviders.twilio:
        return new TwilioDevice();
      case telephonyProviders.plivo:
        return new PlivoDevice(provider);
      case telephonyProviders.plivoInternational:
        return new PlivoDevice(provider);
      case telephonyProviders.retell:
        return RetellDevice;
      default:
        throw new Error(`Unknown provider: ${provider}`);
    }
  }

  createEventHandler(provider, device) {
    switch (provider) {
      case telephonyProviders.twilio:
        return new TwilioEventHandler(device);
      case telephonyProviders.plivo:
        return new PlivoEventHandler(device);
      case telephonyProviders.plivoInternational:
        return new PlivoEventHandler(device);
      case telephonyProviders.retell:
        return RetellEventHandler;
      default:
        throw new Error(`Unknown provider: ${provider}`);
    }
  }
}

export default new TelephonyFactory();
